import { connect } from "react-redux";

import {
    clearFormHandler,
    feedbackHandler,
    formSendToClientForSignAction,
    formSilentSaveAction,
    fufSaveHandler,
} from "../../../Engine/ActionCreators/FormActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { currentViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { getFormRootModelPath } from "../../../Forms/Types/FormSettings";

import { SimpleForm } from "./SimpleForm";

const mapStateToProps = (state: FullFormState) => {
    const bindingPath = getFormRootModelPath(state.settings);
    const controlModel = currentViewModelSelect.controlModel(state, bindingPath);

    return {
        disabledSending: controlModel.disabledSending ?? false,
        showFormContainer: Boolean(state.settings.showFormContainer),
        feedbackEnabled: Boolean(state.settings.feedbackEnabled),
        isDisabledCloseButton: Boolean(state.settings.isDisabledCloseButton),
        isDisabledCleanForm: Boolean(state.settings.isDisabledCleanForm),
        isReadOnly: state.settings.isReadOnly,
        sendToSignButtonOptions: state.settings.sendToSignButton,
        signAndSendButtonOptions: state.settings.signAndSendButton,
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch) => ({
    onSaveFuf: () => dispatch(fufSaveHandler),
    onFormClear: () => dispatch(clearFormHandler),
    onRunFeedback: () => dispatch(feedbackHandler),
    onSendToSign: () => dispatch(formSendToClientForSignAction),
    onSaveForm: () => dispatch(formSilentSaveAction),
});

export const SimpleFormContainer = connect(mapStateToProps, mapDispatchToProps)(SimpleForm);
